import React, { memo } from "react";

// TODO remove or leave
// import classes from './HamburgerIcon.scss';

const HamburgerIcon = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 100 80" width="30" height="20">
      <rect width="100" height="15"></rect>
      <rect y="30" width="100" height="15"></rect>
      <rect y="60" width="100" height="15"></rect>
    </svg>
  );
};

export default memo(HamburgerIcon);
